import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import MicrowaveOutlinedIcon from "@mui/icons-material/MicrowaveOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

export const menuGroups = [
  {
    id: "administration",
    title: "Administration",
    type: "group",
    children: [],
  },
  {
    id: "lands",
    title: "Lands",
    type: "group",
    children: [],
  },
  {
    id: "logistics",
    title: "Logistics",
    type: "group",
    children: [],
  },
  {
    id: "renting_requests",
    title: "Renting Requests",
    type: "group",
    children: [],
  },
  {
    id: "companies",
    title: "Companies",
    type: "group",
    children: [],
  },
  {
    id: "stores",
    title: "Stores and VMs",
    type: "group",
    children: [],
  },
  {
    id: "products",
    title: "Products",
    type: "group",
    children: [],
  },
  {
    id: "maintenance",
    title: "Maintenance",
    type: "group",
    children: [],
  },
  {
    id: "payments",
    title: "Payments",
    type: "group",
    children: [],
  },
];

export const menuItems = {
  dashboard: {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    url: "/dashboard",
    icon: DashboardOutlinedIcon,
  },
  administration: {
    id: "administration",
    title: "Administration",
    type: "item",
    url: "/administration",
    icon: SecurityOutlinedIcon,
  },
  activitylogs: {
    id: "activity_log",
    title: "Activity Log",
    type: "item",
    url: "/activity_log",
    icon: HistoryOutlinedIcon,
  },
  users: {
    id: "users",
    title: "Users",
    type: "item",
    url: "/users",
    icon: GroupOutlinedIcon,
  },
  companies: {
    id: "companies",
    title: "Companies",
    type: "item",
    url: "/companies",
    icon: BusinessOutlinedIcon,
  },
  reports: {
    id: "reports",
    title: "Reports",
    type: "item",
    url: "/reports",
    icon: CreateOutlinedIcon,
  },
  lands: {
    id: "lands",
    title: "Lands",
    type: "item",
    url: "/lands",
    icon: LocationOnOutlinedIcon,
  },
  logistics: {
    id: "packages",
    title: "Packages",
    type: "item",
    url: "/logistics",
    icon: MonetizationOnIcon,
  },
  renting_requests: {
    id: "renting_requests",
    title: "Renting Requests",
    type: "item",
    url: "/renting",
    icon: PersonAddIcon,
  },
  stores_collapse: {
    id: "stores-collapse",
    title: "Stores",
    type: "collapse",
    icon: StoreOutlinedIcon,
    children: [],
  },
  stores: {
    id: "stores",
    title: "Stores",
    type: "item",
    url: "/stores",
    icon: StoreOutlinedIcon,
  },
  store_categories: {
    id: "store-categories",
    title: "Store Categories",
    type: "item",
    url: "/stores/categories",
    icon: CategoryOutlinedIcon,
  },
  vending_machines_collapse: {
    id: "vm-collapse",
    title: "Vending Machines",
    type: "collapse",
    icon: MicrowaveOutlinedIcon,
    children: [],
  },
  vending_machines: {
    id: "vending-machines",
    title: "Vending Machines",
    type: "item",
    url: "/vending-machines",
    icon: MicrowaveOutlinedIcon,
  },
  vending_machine_categories: {
    id: "vending-machines-categories",
    title: "VM Categories",
    type: "item",
    url: "/vending-machines/categories",
    icon: CategoryOutlinedIcon,
  },
  products_collapse: {
    id: "products-collapse",
    title: "Products",
    type: "collapse",
    icon: Inventory2OutlinedIcon,
    children: [],
  },
  products: {
    id: "products",
    title: "Products",
    type: "item",
    url: "/products",
    icon: Inventory2OutlinedIcon,
  },
  product_categories: {
    id: "products-categories",
    title: "Product Categories",
    type: "item",
    url: "/products/categories",
    icon: CategoryOutlinedIcon,
  },
  stock: {
    id: "stock",
    title: "Stock",
    type: "item",
    url: "/stock",
    icon: ShowChartOutlinedIcon,
  },
  transactions: {
    id: "transactions",
    title: "Transactions",
    type: "item",
    url: "/transactions",
    icon: ReceiptOutlinedIcon,
  },
  maintenance_schedule: {
    id: "maintenance-schedule",
    title: "Maintenance",
    type: "item",
    url: "/maintenance",
    icon: EngineeringOutlinedIcon,
  },
  payments: {
    id: "payments",
    title: "Payments",
    type: "item",
    url: "/payments",
    icon: CreditCardOutlinedIcon,
  },
  payment_methods: {
    id: "payment-methods",
    title: "Payment Methods",
    type: "item",
    url: "/payments/methods",
    icon: CreditCardOutlinedIcon,
  },
  settings: {
    id: "settings",
    title: "Settings",
    type: "item",
    url: "/settings",
    icon: SettingsOutlinedIcon,
  },
  contracts: {
    id: "contracts",
    title: "Contracts",
    type: "item",
    url: "/contracts",
    icon: HandshakeOutlinedIcon,
  },
};
